<template>
  <div class="autocomplete2-container pa-0 px-2" style="margin-bottom:-10px">
    <v-text-field
      v-model="name"
      :id="id"
      :label="label"
      clearable
      :disabled="disabled"
      :required="required"
      :rules="rules"
      outlined
      dense
      color="primary"
      background-color="white"
      :autofocus="!name || name.length == 0"
      onfocus="this.setAttribute('autocomplete', 'new-password');"
      class="form-control"
      @click="forceFocus()"
      @click:clear="clear()"
      @input="clearItems()"
      @blur="clearItems()"
      @keydown="
        e => {
          keyDownHandler(e);
        }
      "
    ></v-text-field>
    <div v-show="items && items.length > 0" class="autocomplete2-container">
      <ul
        class="dawa-autocomplete-suggestions"
        style="margin: -1.5em 0 0 0em; overflow"
      >
        <li
          v-for="(item, i) in items"
          :key="i"
          :class="
            i === selectedItem
              ? 'dawa-autocomplete-suggestion dawa-selected'
              : 'dawa-autocomplete-suggestion'
          "
          @mousedown="selectAddress(item)"
        >
          {{ item.name }}, {{ item.address }}, {{ item.zip }} {{ item.city }},
          {{ item.country_code }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { dictionary } from "@/helpers";

export default {
  props: ["addressType", "id", "label", "disabled", "required", "rules"],
  mounted() {
    this.$emit("rendered");
    this.clearItems();
  },
  data: () => ({
    items: [],
    selectedItem: 0
  }),
  computed: {
    name: {
      get() {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          return this.$store.state.booking.data.pickup.address.name;
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          return this.$store.state.booking.data.delivery.address.name;
        }
        return null;
      },
      set(value) {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          this.$store.commit("booking/updatePickupName", value ? value : "");
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          this.$store.commit("booking/updateDeliveryName", value ? value : "");
        }
        this.search(value);
      }
    }
  },
  methods: {
    forceFocus() {
      this.$emit("forceFocus");
    },
    search(val) {
      if (!val) return;

      if (this.isLoading) {
        this.rerunWhenFinished = true;
        return;
      }

      clearTimeout(this._timerId);

      // delay new call 200ms
      this._timerId = setTimeout(() => {
        this.isLoading = true;

        let address = null;
        if (this.addressType === dictionary.constants.address_types.pickup) {
          address = this.$store.state.booking.data.pickup.address;
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          address = this.$store.state.booking.data.delivery.address;
        }

        this.$store
          .dispatch("booking/lookupAddresses", {
            address
          })
          .then(
            response => {
              if (response) {
                this.items = response.slice(0, 20);
              }
            },
            error => {
              console.error(error);
            }
          )
          .finally(() => {
            this.isLoading = false;
            if (this.rerunWhenFinished) {
              this.search("rerun");
              this.rerunWhenFinished = false;
            }
          });
      }, 200);
    },
    clear() {
      this.clearItems();
      if (this.addressType === dictionary.constants.address_types.pickup) {
        this.$store.commit("booking/updatePickupName", "");
      } else if (
        this.addressType === dictionary.constants.address_types.delivery
      ) {
        this.$store.commit("booking/updateDeliveryName", "");
      }
    },
    clearItems() {
      this.items = [];
      this.selectedItem = 0;
    },
    keyDownHandler(e) {
      if (e && this.items && this.items.length > 0) {
        const key = window.event ? e.keyCode : e.which;
        // down (40)
        if (key === 40) {
          this.selectedItem = (this.selectedItem + 1) % this.items.length;
        }
        //up (38)
        else if (key === 38) {
          this.selectedItem =
            (this.selectedItem - 1 + this.items.length) % this.items.length;
        }
        // enter or tab
        else if (key === 13 || key === 9) {
          this.selectAddress(this.items[this.selectedItem]);
        }
        // esc
        else if (key === 27) {
          this.clearItems();
        }
      }
    },
    selectAddress(selected) {
      if (selected) {
        if (this.addressType === dictionary.constants.address_types.pickup) {
          this.$store.commit("booking/updatePickupName", selected.name);

          this.$store.commit("booking/updatePickupAddress", {
            address: selected.address,
            zip: selected.zip,
            city: selected.city,
            country: selected.country_code,
            lat: selected.lat,
            lon: selected.lon
          });
        }
        if (this.addressType === dictionary.constants.address_types.delivery) {
          this.$store.commit("booking/updateDeliveryName", selected.name);

          this.$store.commit("booking/updateDeliveryAddress", {
            address: selected.address,
            zip: selected.zip,
            city: selected.city,
            country: selected.country_code,
            lat: selected.lat,
            lon: selected.lon
          });
        }

        selected.country = selected.country_code; //set country = country_code or loadMatchingTerminalAddress will fail

        this.$emit("selected", selected);
      }
      this.clearItems();
    }
  }
};
</script>

<style lang="scss">
@import url("../../assets/styles/colors.css");

.autocomplete2-container {
  /* relative position for at de absolut positionerede forslag får korrekt placering.*/
  position: relative;
  width: 100%;
  max-width: 40em;
}
.autocomplete2-container input {
  /* Både input og forslag får samme bredde som omkringliggende DIV */
  width: 100%;
  box-sizing: border-box;
}
.dawa-autocomplete-suggestions {
  //margin: 2em 0 0 0;
  margin: 1.3em 0 0 -0.7em;
  padding: 0 !important;
  text-align: left;
  // border-radius: 0.3125em;
  background: white;
  box-shadow: 0 0.0625em 0.15625em rgba(0, 0, 0, 0.15);
  position: absolute;
  left: 0;
  right: 0;
  z-index: 9999;
  overflow-y: auto;
  box-sizing: border-box;
}
.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion {
  margin: 0;
  list-style: none;
  cursor: pointer;
  padding: 0.4em 0.6em;
  color: #333;
  border: 0.0625em solid #ddd;
  border-bottom-width: 0;
}
.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.dawa-autocomplete-suggestions .dawa-autocomplete-suggestion:last-child {
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  border-bottom-width: 0.0625em;
}
.dawa-autocomplete-suggestions
  .dawa-autocomplete-suggestion.dawa-selected
  .dawa-autocomplete-suggestions
  .dawa-autocomplete-suggestion:hover {
  // background: #f0f0f0;
  background: var(--GLS-blue-10);
}
</style>
